import { render, staticRenderFns } from "./IFManageInputs.vue?vue&type=template&id=3fb7423e"
import script from "./IFManageInputs.vue?vue&type=script&lang=js"
export * from "./IFManageInputs.vue?vue&type=script&lang=js"
import style0 from "./IFManageInputs.vue?vue&type=style&index=0&id=3fb7423e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports